/**
=========================================================
* Arakan - v2.1.0
=========================================================

* Product Page: https://www.trakib.com/product/material-dashboard-pro-react
* Copyright 2022 Trakib (https://www.trakib.com)

Coded by www.trakib.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";

// Settings page components
import FormField from "components/FormField";

import crudsService from "services/cruds-service";
import { Autocomplete, Chip, Switch, TextField } from "@mui/material";
import MDInput from "components/MDInput";
import i18n from "i18n";

function MainInfo({
  autoSwitchChangeHandler,
  info,
  setErrors,
  errors,
  notification,
  setNotification,
  types,
}) {
  const { t } = i18n;

  return (
    <Card id="basic-info" sx={{ overflow: "visible" }}>
      <MDBox p={3}>
        <MDTypography variant="h5">بيانات النشر</MDTypography>
      </MDBox>
      <MDBox pb={3} px={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <Autocomplete
              defaultValue={null}
              options={types}
              getOptionLabel={(option) => option.name || ""}
              value={info.type}
              isOptionEqualToValue={(option, item) =>
                option === item || option.id === item.id
              }
              onChange={(e, v) => autoSwitchChangeHandler("type", v)}
              renderInput={(params) => (
                <FormField
                  {...params}
                  label={t("type")}
                  InputLabelProps={{ shrink: true }}
                />
              )}
              renderOption={(props, option, { selected }) => {
                const { key, ...otherProps } = props; // Destructure to exclude key
                return (
                  <li key={option.id} {...otherProps}>
                    {option.name}
                  </li>
                );
              }}
              error={errors.type}
            />
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default MainInfo;
